import { Result } from 'antd';
import styled from 'styled-components';

export const StyledResult = styled(Result)`
  padding: 32px 0;
  font-family: ${props => props.theme.fontFamily};
  .ant-result-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    font-family: inherit;
  }
  &.ant-result-success .ant-result-icon .anticon {
    color: ${props => props.theme.colorSuccess};
  }
  &.ant-result-error .ant-result-icon .anticon {
    color: ${props => props.theme.colorError};
  }
`;
